<template>
  <svg class="xds:icon" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_478_168)">
      <path
        d="M7 1H1V3.4H7V1ZM7 4.6H1V7H7V4.6Z"
        stroke="currentColor"
        stroke-width="0.4"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_478_168">
        <rect width="8" height="8" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
